import {useCallback, useMemo} from "react";
import {useSignal} from "@preact/signals-react";
import {FORMAT_DATE_BACK, formatDate, stringToDate} from "@ui-seeker/utils";

import {GROUPED_BY} from "@constants";
import {ACTION_CHANGE_TYPE, ACTION_REPRICING, SETUP_COMPARISON, VALID_SCOPE} from "../../@constants";
import {repricingFormData} from "../../@signals";


export default function useRepricingFormData(criterion) {
	const ruleID = repricingFormData.value.ruleID
	const ruleName  = repricingFormData.value.name ?? 'New Rule'
	const dataScope = repricingFormData.value.dataScope ?? [{ key: 'market', operation: 'include', value: [] }]
	const priceRule = repricingFormData.value.priceRule ?? SETUP_COMPARISON.HIGHER
	const priceRuleValue = repricingFormData.value.priceRuleValue ?? 0.5
	const criterionDisplayed = dataScope.map(({ key }) => key)
	const actionRepricing = repricingFormData.value.action ?? ACTION_REPRICING.INCREASE
	const actionChangeType = repricingFormData.value.actionType ?? ACTION_CHANGE_TYPE.PERCENTAGE
	const actionValue = repricingFormData.value.actionValue ?? 1
	const emails = repricingFormData.value.email ?? []
	const scheduleDateStart = repricingFormData.value.scheduleDateStart
	const scheduleDateEnd = repricingFormData.value.scheduleDateEnd
	const hours = repricingFormData.value.hour ?? []
	const frequency = repricingFormData.value.frequency ?? []

	const handleChangeValue = useCallback((key, newValue) => repricingFormData.value = {
		...repricingFormData.value,
		[key]: newValue
	}, [])

	const handleChangeScopeValue = useCallback((keyScope, newValue) => repricingFormData.value = {
		...repricingFormData.value,
		dataScope: dataScope.map(criterionData => {
			if (criterionData.key !== criterion) return criterionData
			if (keyScope === 'value' && criterion === GROUPED_BY.STOCK)
				newValue = newValue ? [newValue === 'in_stock'] : []
			return { ...criterionData, [keyScope]: newValue, ...keyScope === 'key' && {
					value: [] //reset Value when change filter
				} }
		})
	}, [JSON.stringify(dataScope), criterion])

	const handleAddScope = useCallback(() => repricingFormData.value = {
		...repricingFormData.value,
		dataScope: [
			...dataScope, {
				key: VALID_SCOPE.filter(item => !criterionDisplayed.includes(item))[0],
				operation: 'include', value: []
			}
		]
	}, [JSON.stringify(dataScope)])

	const handleRemoveScope = useCallback(() => repricingFormData.value = {
		...repricingFormData.value,
		dataScope: dataScope.filter(item => item.key !== criterion)
	}, [JSON.stringify(dataScope), criterion])

	const handleChangeScheduleTime = useCallback(newValue => repricingFormData.value = {
		...repricingFormData.value,
		scheduleDateStart: newValue ? formatDate(newValue[0], { format: FORMAT_DATE_BACK }) : null,
		scheduleDateEnd: newValue ? formatDate(newValue[1], { format: FORMAT_DATE_BACK }) : null
	}, [])

	return {
		ruleID,
		isEditForm: !!repricingFormData.value.ruleID,
		name: ruleName,
		dataScope,
		criterionDisplayed,
		priceRule,
		priceRuleValue,
		actionRepricing,
		isMatchActionType: actionRepricing === ACTION_REPRICING.MATCH,
		actionChangeType,
		isPercentageChangeType: actionChangeType === ACTION_CHANGE_TYPE.PERCENTAGE,
		actionValue,
		emails,
		hours,
		days: frequency,
		scheduleDateStart: scheduleDateStart ? stringToDate(scheduleDateStart) : null,
		scheduleDateEnd: scheduleDateEnd ? stringToDate(scheduleDateEnd) : null,
		haveSchedule: !!hours.length || !!frequency.length || !!scheduleDateStart || !!scheduleDateEnd,

		dataSend: {
			ruleID: ruleID,
			name: ruleName,

			dataScope: dataScope,


			priceRule: priceRule,
			priceRuleValue: priceRuleValue ? parseFloat(priceRuleValue) : null,

			action: actionRepricing,
			actionType: actionChangeType,
			actionValue: actionValue ? parseFloat(actionValue) : null,
			actionSiteID: [],
			email: emails,
			scheduleDateStart: scheduleDateStart,
			scheduleDateEnd: scheduleDateEnd,
			hour: hours || [],
			enabled: repricingFormData.value.enabled,
			frequency: frequency || []
		},

		handleChangeValue,
		handleChangeScopeValue,
		handleAddScope,
		handleRemoveScope,
		handleChangeScheduleTime
	}
}